export const CustomerServiceEndpoints = {
  UpdateRegistrationDetails: `/UniversalPracticeRegistration/UpdateRegistrationDetails`,
  CommitRegistrationDetails: `/UniversalPracticeRegistration/CommitRegistrationDetails`,
};
